// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__3lNHf","buttons":"PendingPaymentAlert_buttons__1-pVD"};